//获取url携带参数
const qs = (() => {
    var assoc = {};
    var decode = function (s) {
        return decodeURIComponent(s.replace(/\+/g, " "));
    };
    var queryString = location.search.substring(1);
    var keyValues = queryString.split('&');
    for(var i = 0, ii = keyValues.length; i < ii; i++) {
        var key = keyValues[i].split('=');
        if (key.length > 1) {
            assoc[decode(key[0])] = decode(key[1]);
        }
    }
    return assoc;
})();

//返回UA
const ua = (() => {
    var userAgent = navigator.userAgent.toLowerCase();
    var is_iphone_qqnative = (/(iphone|ipod|ipad)/i.test(userAgent) && / QQ/i.test(navigator.userAgent));
    var is_android_qqnative = (/android/.test(userAgent) && /\sQQ/i.test(navigator.userAgent) && /QQ/i.test((navigator.userAgent).split('MQQBrowser')));

    // KuaikanMiniProgram/1.0.0/542000(iPhone;iOS 12.0.1;iPhone 6;qq;WIFI;1334*750)
    // KuaikanMiniProgram/1.0.0/542000(iPhone;iOS 10.0.1;iPhone 6/7/8;wechat;WIFI;1334*750)
    var wechatmini = false;
    var qqmini = false;
    var baidumini = false;
    var miniprogram = false;
    var alipaymini = false;
    var ucmini = false;
    var quarkmini = false;
    var kuaishoumini = false;
    var harmonymini = false;
    var douyinmini = false;
    var quickappmini = false;
    var miniuseragent = qs['useragent'] ? qs['useragent'].toLowerCase() : '';
    if(/kuaikanminiprogram/.test(miniuseragent)) {
        miniprogram = true;
        if(/wechat/.test(miniuseragent)) {
            wechatmini = true;
        }
        if(/qq/.test(miniuseragent)) {
            qqmini = true;
        }
        if(/baidu/.test(miniuseragent)) {
            baidumini = true;
        }
        if(/alipay|uc|quark/.test(miniuseragent)) {
            alipaymini = true;
        }
        if(/uc/.test(miniuseragent)){
            ucmini = true;
        }
        if(/quark/.test(miniuseragent)){
            quarkmini = true;
        }
        if(/kuaishou/.test(miniuseragent)) {
            kuaishoumini = true;
        }
        if(/harmony/.test(miniuseragent)) {
            harmonymini = true;
        }
        if(/douyin/.test(miniuseragent)) {
            douyinmini = true;
        }
        if(/quickapp/.test(miniuseragent)) {
            quickappmini = true;
        }
    }

    // app内获取App的版本  小程序内获取小程序的版本
    var appversion = 0;
    var miniversion = 0;
    var ag = miniprogram ? miniuseragent : userAgent
    var re = ag.match(/\/[0-9]{6}\(/) || [];
    if (re[0]) {
        re = re[0].match(/[0-9]{6}/) || [];
        var version = re[0] || ''
        if (miniprogram) { miniversion = version }
        else { appversion = version }
    }

    function isWkwebview() {
        /*
        * wk迭代版本中出现累加多个页面的ua情况，原先包含webview/wk的判断失效。异常ua表现如下
        *   User-Agent:
        *    Kuaikan/5.66.0/566000(iPhone;iOS 13.3;Scale/3.00;WiFi;2436*1125) webview/ui
        *    Kuaikan/5.66.0/566000(iPhone;iOS 13.3;Scale/3.00;WiFi;2436*1125) webview/wk
        *    Mozilla/5.0 (iPhone; CPU iPhone OS 13_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148  kdtUnion_8a6399314b6c8fd133
        * 第一行才是正确的webview-ua标示，因而有了下面逻辑判断。客户端已知问题在计划567000版本修复
        */
        let ua      = navigator.userAgent.toLowerCase();
        let indexUi = ua.indexOf('webview/ui');
        let indexWk = ua.indexOf('webview/wk');
        if (indexWk == -1) return false;
        if (indexUi == -1) return true;
        if (indexUi < indexWk) return false;
        return true;
    }

    function canMiniPay() {
        let ios = /(iphone|ipod|ipad)/i.test(userAgent)
        // 默认白名单(alipay quark) 白名单中的 ios 小程序可以支付
        // 如果连接中传入白名单(white_list=a,b,c) 则会覆盖默认白名单(采用覆盖的原因是防止以后 alipay quark 取消支持)
        let whiteListStr = qs['white_list']
        let whiteList = whiteListStr ? whiteListStr.split(',') : ['alipay', 'quark']
        // 安卓所有小程序均可支付
        if (!ios) return true
        // 不在白名单里的ios小程序将无法支付 业务方根据 canminipay 做相应处理
        return whiteList.some(item => {
            return miniuseragent.indexOf(item) >= 0
        })
    }

    return {
        miniversion: parseInt(miniversion) || 0,
        appversion : parseInt(appversion) || 0,
        iphone: /(iphone|ipod|ipad)/i.test(userAgent),
        android: /android/.test(userAgent),
        weixin: /micromessenger/.test(userAgent),
        weibo: /weibo/.test(userAgent),
        // qqnative: /qq\//.test(userAgent),
        qqnative: (is_android_qqnative || is_iphone_qqnative),
        qq: /qq/.test(userAgent),
        kkmh: /kuaikan\//.test(userAgent),
        alipay: /alipay/.test(userAgent),
        meipai: /com.meitu.mtmv/.test(userAgent),
        pc: !/(iphone|ipod|ipad|android|webos|blackberry)/.test(userAgent),
        miniprogram:miniprogram,
        wechatmini:wechatmini,
        qqmini:qqmini,
        baidumini:baidumini,
        alipaymini:alipaymini,
        ucmini:ucmini,
        quarkmini:quarkmini,
        kuaishoumini:kuaishoumini,
        harmony: harmonymini,
        douyinmini: douyinmini,
        quickapp: quickappmini,
        dev:/\.cn/.test(location.host) && /dev-/.test(location.host),
        stag:/\.cn/.test(location.host) && !/dev-/.test(location.host),
        prod:/\.com/.test(location.host) && !/mini\.kkmh\.com/.test(location.host),
        local:/\S/.test(location.port),
        wkwebview: isWkwebview(),
        canminipay: canMiniPay()
    };
})();

// 动态加载js文件
const getScript = (src, cb) => {
      var script = document.createElement('script')
      var script0 = document.getElementsByTagName('script')[0];
      script.async = 1;
      script.src = src;
      script0.parentNode.insertBefore(script, script0);
      script.onload = function () {
            cb && cb();
      }
}

export {
    qs,
    ua,
    getScript,
}




// WEBPACK FOOTER //
// ./node_modules/@kk/utils/src/browser.js